import React from "react";
import { styled } from "../../../stitches.config";
import Link from "../../Link";
import { inject, observer } from "mobx-react";

@inject("ArticleStore")
@observer
export default class Tags extends React.Component {
  render() {
    const ArticleStore = this.props.ArticleStore;
    if (ArticleStore.fetchedArticle.topics.length > 0) {
      return (
        <div className="container">
          <TagsWrapper>
            <span> Zobacz także: </span>
            {ArticleStore.fetchedArticle.topics.map(topic => (
              <li key={topic.url}>
                {" "}
                <Link to={topic.url}> {topic.name}</Link>{" "}
              </li>
            ))}
          </TagsWrapper>
        </div>
      );
    }
    return null;
  }
}

export const TagsWrapper = styled("ul",{
  margin: "0",
  marginTop: "20px",
  marginLeft: "-7px",
  padding: "0",
  display: "flex",
  listStyle: "none",
  flexWrap: "wrap",
  width: "100%",
  span: {
    display: "block",
    flexBasis: "100%",
    fontSize: "19px",
    fontWeight: 700,
    marginLeft: "7px",
    marginBottom: "5px",
    color: "$grayscale100"
  },
  a: {
    display: "inline-block",
    color: "$primary",
    fontSize: "13px",
    fontWeight: 700,
    margin: "0 7px"
  }
});
